import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import getConstants from '../../../../constants'
import StoreHours from '../StoreHours'
import StoreCategories from '../StoreCategories'
import StoreLocation from '../StoreLocation'
import Recruitment from '../Recruitment'
import * as storesUtils from 'services/Stores/utils'
import './styles.css'
import StoreTransportation from '../StoreTransportation'
import StoreAnnouncements from '../StoreAnnouncements'
import { convertTime } from 'helpers/hourConverter'
import StoreParking from '../StoreParking'
import { CollectionList } from 'shared-global-ec-uikit/components/dist/react/esm'
import StoreNameWithStatus from '../StoreNameWithStatus'

const { HOME_PAGE_URL, SHOW_TIME_IN_MILITARY } = getConstants()

const getImagesUrl = (props: any) => {
  const listOfImages = []
  if (props.storeInfo.storeImages) {
    for (const [, val] of Object.entries(props.storeInfo.storeImages) as any) {
      listOfImages.push(val.url)
    }
  }
  return listOfImages
}

const StoreInfo = (props: any) => {
  const { footer } = props
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'Store',
            name: props.storeInfo.storeName,
            address: {
              '@type': 'PostalAddress',
              streetAddress: props.storeInfo.address,
            },
            url: HOME_PAGE_URL,
            telephone: props.storeInfo.phone,
            logo:
              'https://faq-ca.uniqlo.com/resource/1513759597000/FRCS_FAQ/img/logo.png',
            geo: {
              '@type': 'GeoCoordinates',
              latitude: props.storeInfo.latitude,
              longitude: props.storeInfo.longitude,
            },
            hasMap: storesUtils.getMapsLink({
              storeDetails: props.storeInfo,
            }),
            image: [getImagesUrl(props)],
            openingHoursSpecification: [
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Monday',
                opens: convertTime(
                  props.storeInfo.monOpenAt,
                  SHOW_TIME_IN_MILITARY,
                ),
                closes: convertTime(
                  props.storeInfo.monCloseAt,
                  SHOW_TIME_IN_MILITARY,
                ),
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Tuesday',
                opens: convertTime(
                  props.storeInfo.tueOpenAt,
                  SHOW_TIME_IN_MILITARY,
                ),
                closes: convertTime(
                  props.storeInfo.tueCloseAt,
                  SHOW_TIME_IN_MILITARY,
                ),
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Wednesday',
                opens: convertTime(
                  props.storeInfo.wedOpenAt,
                  SHOW_TIME_IN_MILITARY,
                ),
                closes: convertTime(
                  props.storeInfo.wedCloseAt,
                  SHOW_TIME_IN_MILITARY,
                ),
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Thursday',
                opens: convertTime(
                  props.storeInfo.thuOpenAt,
                  SHOW_TIME_IN_MILITARY,
                ),
                closes: convertTime(
                  props.storeInfo.thuCloseAt,
                  SHOW_TIME_IN_MILITARY,
                ),
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Friday',
                opens: convertTime(
                  props.storeInfo.friOpenAt,
                  SHOW_TIME_IN_MILITARY,
                ),
                closes: convertTime(
                  props.storeInfo.friCloseAt,
                  SHOW_TIME_IN_MILITARY,
                ),
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Saturday',
                opens: convertTime(
                  props.storeInfo.satOpenAt,
                  SHOW_TIME_IN_MILITARY,
                ),
                closes: convertTime(
                  props.storeInfo.satCloseAt,
                  SHOW_TIME_IN_MILITARY,
                ),
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Sunday',
                opens: convertTime(
                  props.storeInfo.sunOpenAt,
                  SHOW_TIME_IN_MILITARY,
                ),
                closes: convertTime(
                  props.storeInfo.sunCloseAt,
                  SHOW_TIME_IN_MILITARY,
                ),
              },
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: 'Holiday',
                opens: convertTime(
                  props.storeInfo.holOpenAt,
                  SHOW_TIME_IN_MILITARY,
                ),
                closes: convertTime(
                  props.storeInfo.holCloseAt,
                  SHOW_TIME_IN_MILITARY,
                ),
              },
            ],
          })}
        </script>
      </Helmet>
      <>
        <CollectionList keylines="between-items" spacing="24">
          <StoreNameWithStatus {...props} />
          <StoreLocation {...props} />
          <StoreHours {...props} />
          {props.storeInfo.trainAccess && (
            <StoreTransportation {...props} method="train" />
          )}
          {props.storeInfo.busAccess && (
            <StoreTransportation {...props} method="bus" />
          )}
          {props.storeInfo.carAccess && (
            <StoreTransportation {...props} method="car" />
          )}
          <StoreCategories {...props} />
          {props.storeInfo.parkingComment && (
            <StoreParking parkingComment={props.storeInfo.parkingComment} />
          )}
          {(props.storeInfo.freeComment || props.storeInfo.paymentMethod) && (
            <StoreAnnouncements
              announcement={props.storeInfo.freeComment}
              paymentComment={props.storeInfo.paymentMethod}
            />
          )}
          {props.storeInfo.recruitFlag && <Recruitment {...props} />}
        </CollectionList>
      </>

      {footer}
    </>
  )
}

export default StoreInfo
